import { Component, OnInit, Input } from '@angular/core';
import { ProfileFormOption, Preference } from '@shared/models/data';
import { BaseMultipleOptionsField } from '@shared/form-fields/base-multiple-options-field';
import { FormOptionsMapperService } from '@shared/services/forms/form-options-mapper.service';
import { FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FieldsPrerequisite } from '@shared/models/data/fieldsPrerequisite';
import { FormValidatorService } from '@shared/services/forms/form-validator.service';
import { FormFieldConstants } from '../models/form-field';
import { ApplicantService } from '@shared/services/forms/applicant.service';
import { Constants } from '@shared/services/constants/constants';
import { ApplicationService } from '@shared/services/administration/application.service';


@Component({
  selector: 'app-aaos-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.scss']
})
export class DropDownComponent extends BaseMultipleOptionsField implements OnInit {

  @Input() formOptions: ProfileFormOption[];
  @Input() fieldsPrerequisite: FieldsPrerequisite;
  formControlName: string;
  selectedValue: string;
  @Input() dynamicForm: FormGroup;
  isRequired = true;
  showUsaCanadaError = false;
  isUsaCanadaRestricted = false;
  loading = false;
  private originalFieldValidator: ValidatorFn | null = null;

  constructor(
    formFieldsOptionsMapper: FormOptionsMapperService,
    private applicantService: ApplicantService,
    private applicationService: ApplicationService,
  ) {
    super(formFieldsOptionsMapper);
  }

  ngOnInit() {
    this.buildFormGroup();
    this.populateFormGroup();
    this.baseFormGroup.updateValueAndValidity();
    this.validateFormGroup();
    if (this.field && !this.field.fieldIsDisabled) {
      super.ngOnInit();
      this.options = Object.assign([], this.options);
    }

    const constField = this.baseFormGroup.get(this.field.name);
    if (this.field.displayName.indexOf('Optional') !== -1) {
      this.options.unshift(new Preference);
      this.isRequired = false;
      constField.setValidators([Validators.nullValidator]);
    } else {
      this.baseFormGroup.controls[this.field.name].setValidators(Validators.required);
    }
    this.setValidatorForLanguage();
    this.baseFormGroup.updateValueAndValidity();
    this.field.displayValue = this.options.find(x => x.preferenceCode === this.field.value)?.preferenceDescription;
    this.checkUsaCanadaRestriction();
  }

  private checkUsaCanadaRestriction(): void {
    const fieldId = (this.field.id || '').toUpperCase();
    if (fieldId !== Constants.FormField.CountryOfResidenceId.toUpperCase() &&
        fieldId !== Constants.FormField.CountryOfEmploymentId.toUpperCase()) {
      return;
    }
    const appTypeId = (this.applicantService.getApplicationTypeId() || '').toUpperCase();
    this.isUsaCanadaRestricted = Constants.MemberApplicationTypes.UsaCanadaOnlyIds
      .some(id => id.toUpperCase() === appTypeId);

    if (this.isUsaCanadaRestricted) {
      this.originalFieldValidator = this.baseFormGroup.get(this.field.name).validator;
      const currentValue = this.field.value;
      if (currentValue && currentValue !== 'USA' && currentValue !== 'CAN') {
        this.showUsaCanadaError = true;
        const fieldControl = this.baseFormGroup.get(this.field.name);
        fieldControl.setValidators(
          this.originalFieldValidator
            ? [this.originalFieldValidator, () => ({ usaCanadaOnly: true })]
            : [() => ({ usaCanadaOnly: true })]
        );
        fieldControl.updateValueAndValidity();
      }
    }
  }

  setValidatorForLanguage() {
    if (this.fieldsPrerequisite.formModuleTitle === 'Language') {
      this.baseFormGroup.setValidators([Validators.required, FormValidatorService.getLanguageValidator()]);
      this.baseFormGroup.updateValueAndValidity();
    }
  }

  componentChange() {
    this.field.value = this.selectedValue;
    this.field.displayValue = this.options.find(x => x.preferenceCode == this.selectedValue)?.preferenceDescription;

    if (this.isUsaCanadaRestricted) {
      const fieldControl = this.baseFormGroup.get(this.field.name);
      const isAllowedCountry = this.selectedValue === 'USA' || this.selectedValue === 'CAN';
      this.showUsaCanadaError = !isAllowedCountry;

      if (!isAllowedCountry) {
        fieldControl.setValidators(
          this.originalFieldValidator
            ? [this.originalFieldValidator, () => ({ usaCanadaOnly: true })]
            : [() => ({ usaCanadaOnly: true })]
        );
      } else {
        fieldControl.setValidators(this.originalFieldValidator);
      }
      fieldControl.updateValueAndValidity();
    }

    this.validateFormGroup();
    this.componentChanged.emit(this.field);
  }

  restartApplication() {
    this.loading = true;
    this.applicationService.restartApplication().subscribe(() => {
      window.location.href = window.location.origin;
    });
  }
}
